module.exports = __webpack_public_path__ + "static/img/product-show.04070fcf.png";